import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/PartnersTable.vue"),
          meta: { title: "Список партнеров", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create",
          component: () => import("@/views/forms/PartnersForm.vue"),
          meta: { title: "Создать партнера", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/PartnersForm.vue"),
          meta: { title: "Редактировать партнера", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
  ];
};
